import {
  type CreateOrUpdatePolicyRequest,
  RoutingPolicyModel,
} from "@shared/types/common";
import { DateTime } from "luxon";
import myJFrogUtils from "@shared/utils/myJFrogUtils.ts";
import { sleep } from "@shared/utils/tools.ts";

export default async (data?: object) => {
  const request = data as CreateOrUpdatePolicyRequest;
  await sleep(350);
  return {
    createdAt: DateTime.now().toISO(),
    policy_type: request.policy_type,
    policy_status: "enabled",
    routing_policy_id: myJFrogUtils.generateUUIDv4(),
    subscription_id: request.subscription_id,
    routing_url: request.routing_url,
    policy_details: request.policy_details,
    target_jpd_technical_server_name: request.target_jpd_technical_server_name,
  } satisfies RoutingPolicyModel;
};
